module.exports = __webpack_public_path__ + "static/media/Kuva_hero.15a21e86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Kuva_hero.jpg
// module id = 1409
// module chunks = 0